import {Component, Input, OnInit} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';

@Component({
  selector: 'app-gdpr-alert',
  templateUrl: './gdpr-alert.component.html',
  styleUrls: ['./gdpr-alert.component.scss']
})
export class GdprAlertComponent implements OnInit {
  @Input() opened: boolean;

  constructor( private cookieService: CookieService) { }

  ngOnInit(): void {
  }

  done() {
    const dateAfterOneYear = new Date();
    dateAfterOneYear.setFullYear(dateAfterOneYear.getFullYear() + 1);
    this.cookieService.set('gdpr', 'ok', dateAfterOneYear);
    this.opened = false;
  }
}
